import { CommonFunctions } from "../static/common-functions";
import { DateFunctions } from "../static/date-functions";
import { BaseBus } from "./BaseBus";
export class ComponentBus extends BaseBus{

    constructor(busObj: ComponentBus) {
        super(busObj);

    }
    CID(): any {
        return this.componentID;
    }
    setId(id: any) {
        this.componentID = id;
    }
    setParentId(id: any) {
        this.bidDetailID = id;
    }
    initialize(data: ComponentBus) {
        super.initialize(data);
        this.insertDt = CommonFunctions.getDate(data.insertDt);
        this.updateDt = CommonFunctions.getDate(data.updateDt);
    }
    setNew(userId: any, date: Date, companyId: any = null, personId: any = null, parentId: any = null, other: any = null) {
    }
    setFromForm(data: ComponentBus) {
        super.setFromForm(data);
        let dateNow = CommonFunctions.getDateNow();

        if (this.hasId) {
            this.insertDt = data.insertDt;
            this.compInsertUserId = data.compInsertUserId;
        }
        else {
            this.insertDt = dateNow;
            this.compInsertUserId = data.compInsertUserId;
        }

    }
    setBeforeSave() {
        this.insertDt = DateFunctions.getDateTimeWithUTCOffset(this.insertDt);
        this.updateDt = DateFunctions.getDateTimeWithUTCOffset(this.updateDt);

    }
    setCommon(userId: any, date: Date, companyId: any = null) {
        this.updateDt = date;
        if (this.hasId) {
            this.compUpdateUserId = userId;

        }
        else {
            this.insertDt = date;
            this.compInsertUserId = userId;
             this.compUpdateUserId = userId;
        }
    }

    componentID :string;
    bidDetailID : string;
    catogory  : string;
    type : string;
    qty : number;
    material:string;
    pipeFitter:number;
    caseSetter:number;
    labor:number;
    remark:string;
    compInsertDt:Date;
    categoryDesc:Date;
    categoryTypeDesc:string;
    categoryName:string;
    categoryTypeName:string
    insertDt: Date;
    updateDt: Date;
    compUpdateDt: string;
    compUpdateUserId:string;
    compInsertUserId : string;
}